<template>
  <div class="setAdmin">
    <el-dialog
      title="创建分账合约"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="880px"
      :before-close="close"
    >
      <el-form
        ref=""
        :model="from"
        size="small"
        label-width="72px"
      >
        <el-form-item label="产品项目">
          <el-select style="width: 320px" v-model="from.projectId" placeholder="请选择产品项目">
            <el-option v-for="item of projectList" :key="item.id" :label="item.projectName" :value="item.id" />
          </el-select>
        </el-form-item>
      </el-form>
      <el-table border v-loading="loading" :data="data" class="table">
        <el-table-column label="选择" align="center" width="65">
          <template scope="{ row }">
            <el-radio
              v-model="contractInfo.splitContractId"
              :label="row.contractId"
              @change.native="handleSelectChange(row)"
            >&nbsp;</el-radio>
          </template>
        </el-table-column>
        <el-table-column label="合约ID" align="center" width="200">
          <template slot-scope="{ row }">
            <span>{{ row.contractId || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="分账合约编号" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.contractNo || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="合约名称" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.contractName || "--" }}</span>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" @click="handleChoose">保 存</el-button>
        <el-button size="small" @click="close">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getSplitContractList,
  addSplitContract
} from "@/api/organization"
import { getPageList } from '@/api/product/project'
export default {
  data() {
    return {
      loading: false,
      dialogVisible: false,
      from: {
        projectId: ''
      },
      projectList: [],
      data: [],
      companyId: '',
      contractInfo: {
        splitContractId: '',
        splitContractName: '',
        splitSubjectId: '',
        splitType: ''
      }
    };
  },
  methods: {
    // 保存
    handleChoose({ contractId, contractName }) {
      if (!this.from.projectId) {
        this.$message.warning('请选择产品项目!')
        return
      }
      if (!this.contractInfo.splitContractId) {
        this.$message.warning('请选择合约!')
        return
      }
      const s = this.projectList.find(({ id }) => id === this.from.projectId)

      this.$confirm("确认要绑定该分账合约吗?", "提示", {
        closeOnClickModal: false,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          const params = {
            companyId: this.companyId,
            projectId: this.from.projectId,
            projectName: s.projectName,
            ...this.contractInfo
          }
          addSplitContract(params).then(({ code }) => {
            if (code === 0) {
              this.$message.success('绑定成功!')
              this.$emit('refresh')
              this.close()
            }
          })
        })
        .catch(() => {});
    },
    handleSelectChange(val) {
      this.contractInfo.splitContractId = val.contractId
      this.contractInfo.splitSubjectId = val.contractNo
      this.contractInfo.splitContractName = val.contractName
      if (val.contractContent) {
        const r = JSON.parse(val.contractContent)
        this.contractInfo.splitType = r.splitType
      }
    },
    // 获取产品项目
    getProjectList () {
      getPageList({ page: 1, limit: -1, status: 1 }).then(({ code, data }) => {
        if (code === 0 && data) {
          this.projectList = data.records || []
        }
      })
    },
    async handleGetContracts(flag) {
      this.loading = true;
      const res = await getSplitContractList({ flag })
      this.data = res.data || [];
      this.loading = false;
    },
    // 初始化
    init(id, flag) {
      this.companyId = id || "";
      this.getProjectList()
      this.handleGetContracts(flag)
      this.dialogVisible = true;
    },
    // 关闭
    close() {
      this.dialogVisible = false;
    }
  },
};
</script>

<style lang="scss" scoped>
.setAdmin {
  .title {
    margin: 0px 0 10px;
  }
  .blue_Box {
    margin: 0 6px;
    color: #2d8cf0;
    cursor: pointer;
  }

  .blue_Box:hover {
    color: #57a3f4;
  }
  .table {
    ::v-deep .el-radio__label {
      display: none;
    }
  }
}
</style>
